<template>
  <v-form ref="form" v-model="valid">
    <v-text-field v-model="userid" :rules="nameRules" label="Identifiant" required></v-text-field>
    <v-text-field v-model="firstname" :rules="nameRules" label="Firstname" required></v-text-field>
    <v-text-field v-model="lastname" :rules="nameRules" label="Lastname" required></v-text-field>
    <v-col cols="11">
      <v-select v-model="role" :items="roles" :rules="nameRules" label="Role" :return-object="true"></v-select>
    </v-col>
    <v-col cols="11">
      <v-btn :disabled="!valid" color="success" @click="validate">Insert</v-btn>
    </v-col>
    <v-col cols="11">
      <v-btn :to="{ name: 'Dashboard' }" color="white">Dashboard</v-btn>
    </v-col>
    <div v-if="errors.length">
      <b>Erreur(s):</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div v-if="status.length">
      <b>Insertions</b> {{ status }}
    </div>
  </v-form>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      firstname: null,
      userid: null,
      lastname: null,
      role: null,
      roles: [],
      status: [],
      nameRules: [v => !!v || 'required'],
      errors: []
    }
  },
  created () {
    this.getRoles()
  },
  methods: {
    getRoles () {
      this.$apiclient.getRoles()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.roles = (response.data != null) ? response.data : []
        })
        .catch(error => { this.errors.push(error.response.statusText) })
    },
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        var errs = this.errors
        var statuses = this.status
        this.$apiclient.addUser(this.userid, this.firstname, this.lastname, this.role)
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            this.errors = []
            var str = 'Ok id=' + response.data['UserId'] + ' password=' + response.data['Password']
            statuses.push(str)
            this.valid = false
          })
          .catch(error => {
            this.status = []
            if (error.response.status === 401) {
              errs.push("Vous n'êtes pas connecté ou non authorisé")
            } else if (error.response.status === 409) {
              errs.push('Utilisateur existe déjà')
            } else {
              errs.push(error.response.statusText)
            }
          })
      })
    }
  }
}
</script>
